import LoadingScreen from "components/loading-screen"
import useMainClass from "hooks/use-main-cass"
import { lazy, Suspense } from "react"
import { Redirect, Route } from "react-router-dom"
import RoutesWithNotFound from "utilities/routes-with-not-found"

const Start = lazy(() => import('./views/start'))
const Details = lazy(() => import('./views/details'))
const Ranking = lazy(() => import('./views/ranking'))
const Invite = lazy(() => import('./views/invite'))

export default function GroupsRouter() {
  useMainClass('groups')

  return (
    <Suspense fallback={<LoadingScreen />}>
      <RoutesWithNotFound>
        <Route path="/groups" component={() => <Redirect to={`/groups/start`} />} exact />
        <Route path="/groups/start" component={Start} exact />
        <Route path="/groups/invite" component={Invite} exact />
        <Route path="/groups/details/:id" component={Details} exact />
        <Route path="/groups/ranking/:id" component={Ranking} exact />
      </RoutesWithNotFound>
    </Suspense>
  )
}